import { inject, Injectable } from "@angular/core";

import { AppLocalStorageService } from "../local-storage-services/app-local-storage.service";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable({
    providedIn: 'root'
})
export class AppStorageService
{
    private readonly _appLocalStorageService = injectRequired(AppLocalStorageService);

    appData$$ = this._appLocalStorageService.appData$$;
    domainProfileData$$ = this.appData$$.domainProfile;
    defaultDomainProfileData$$ = this.appData$$.defaultDomainProfile;
}
